import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['section', 'instructionEnd']

  connect() {
    this.check()
  }

  done(event) {
    event.currentTarget.dataset.done = 'true'
    this.check()
  }

  reset(event) {
    event.currentTarget.dataset.done = 'false'
    this.check()
  }

  check(){
    let done = true

    this.sectionTargets.forEach((section) => {
      if (section.dataset.done !== 'true') {
        done = false
      }
    })

    if (done) {
      this.instructionEndTarget.classList.remove('d-none')
      Rails.fire(this.element, 'sectioncomplete')
    } else {
      this.instructionEndTarget.classList.add('d-none')
      Rails.fire(this.element, 'sectionincomplete')
    }
  }
}
